import { useContext, useLayoutEffect, useMemo, useState } from "react"
import MapLayerManager from "./MapLayerManager"
import { LeftPanelContext } from "panels/routing/LeftPanelContext"
import { TopBarContext } from "panels/routing/TopBarContext"
import { BottomBarContext } from "panels/routing/BottomBarContext"
import { MapSearch } from "./search/MapSearch"
import { computeSnapshotFrame } from "@nova/component-map-snapshot"
import { useViewport } from "./GlobalViewState"

const SearchBarInSnapshot = () => {
    const viewport = useViewport()
    const snapshotBorderOffset = useMemo(() => {
        const { offsetY } = computeSnapshotFrame({
            viewport,
            maxHeight: 0.8,
            maxWidth: 0.9,
        })
        return offsetY
    }, [viewport])
    return (
        <>
            <div
                className="w-96 max-w-[90vw] absolute left-1/2 -translate-x-1/2"
                style={{ bottom: snapshotBorderOffset + 16 }}
            >
                <div className="flex-1 flex items-center justify-center pointer-events-auto relative h-9">
                    <MapSearch />
                </div>
            </div>
        </>
    )
}

export const MapAreaSelector = () => {
    const { register: leftPanelRegister, unregister: leftPanelUnregister } =
        useContext(LeftPanelContext)
    const { register: topBarRegister, unregister: topBarUnregister } = useContext(TopBarContext)
    const { registerBottomBar, unregisterBottomBar } = useContext(BottomBarContext)
    const [active, setActive] = useState(false)

    useLayoutEffect(() => {
        leftPanelRegister({ Item: () => <></>, key: "area-selector-blank" })
        topBarRegister({ Item: () => <></>, key: "area-selector-blank" })
        registerBottomBar({
            Item: SearchBarInSnapshot,
            key: "area-selector-blank",
        })
        setActive(true)
        return () => {
            leftPanelUnregister("area-selector-blank")
            topBarUnregister("area-selector-blank")
            unregisterBottomBar("area-selector-blank")
        }
    }, [
        registerBottomBar,
        unregisterBottomBar,
        leftPanelRegister,
        leftPanelUnregister,
        topBarRegister,
        topBarUnregister,
    ])
    return active ? <MapLayerManager /> : null
}
